module.exports = __webpack_public_path__ + "static/media/file-searching.521df1b9.svg";